import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { UpdateProductForm } from '../../modules/product';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';

const ProductUpdateView = () => {
    const { params: { id } } = useRouteMatch();

    return (
        <EditScreenLayout isDesktopLarge path={routePaths.products}>
            <UpdateProductForm productId={id} />
        </EditScreenLayout>
    );
};


export default ProductUpdateView;
